import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  type ChartConfiguration
} from 'chart.js';
import type { CalculatorOutput } from './types';

Chart.register(LineController, LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend);

let chart: Chart | null = null;

export function renderChart(canvas: HTMLCanvasElement, output: CalculatorOutput): void {
  const labels = output.series.map((point) => `Year ${point.year}`);
  const cumulativeUplift = output.series.map((point) => Math.round(point.cumulative_uplift));
  const netAfterTuition = output.series.map((point) => Math.round(point.net_after_tuition));

  const config: ChartConfiguration<'line'> = {
    type: 'line',
    data: {
      labels,
      datasets: [
        {
          label: 'Cumulative earnings uplift',
          data: cumulativeUplift,
          borderColor: '#cc0000',
          backgroundColor: 'rgba(204,0,0,0.14)',
          pointRadius: 2,
          tension: 0.22
        },
        {
          label: 'Net after tuition',
          data: netAfterTuition,
          borderColor: '#2d2926',
          backgroundColor: 'rgba(45,41,38,0.12)',
          pointRadius: 2,
          tension: 0.22
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          ticks: {
            callback: (value) => `$${Number(value).toLocaleString('en-US')}`
          }
        },
        x: {
          ticks: {
            color: '#63666a'
          }
        }
      }
    }
  };

  if (chart) {
    chart.destroy();
  }

  chart = new Chart(canvas, config);
}
